import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-dfc-business-gym.component.scss';
var FormItemDfcBusinessGym = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemDfcBusinessGym, _super);
    function FormItemDfcBusinessGym(element) {
        return _super.call(this, element) || this;
    }
    FormItemDfcBusinessGym.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now__button-business_dfc"));
        this.businessType = this.element.querySelector(".js-business-type");
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
    };
    FormItemDfcBusinessGym.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.businessType) {
            this.businessType.addEventListener("change", function () { return _this.validateBusinessType("validate"); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.resetForm();
        }, false);
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
    };
    FormItemDfcBusinessGym.prototype.validateBusinessType = function (type) {
        var _this = this;
        // Business Reg Validations
        function dfcBusinessFormatBusinessReg(event) {
            var _stringLength = parseFloat(event.length);
            var _newLength = (_stringLength - 1);
            var _check = event.substring(_newLength);
            var reg = new RegExp('^[0-9]+$');
            if (reg.test(_check)) {
                if (event.length === 4) {
                    event = event += '/';
                }
                else if (event.length === 11) {
                    event = event += '/';
                }
                else if (event.length > 14) {
                    event = event.substring(0, 14);
                }
            }
            else {
                return event.substring(0, _newLength);
            }
            return event;
        }
        function dfcBusinessFormatExpression(inputText) {
            var _check = inputText.split('/');
            if (_check.length > 1) {
                var _valid1 = true;
                var _valid2 = true;
                var _valid3 = true;
                if (_check.length === 3) {
                    var _seg1 = new RegExp('^/d{4}$');
                    var _seg2 = new RegExp('^/d{6}$');
                    var _seg3 = new RegExp('^/d{2}$');
                    if (_seg1.test(_check[0])) {
                        _valid1 = false;
                    }
                    if (_seg2.test(_check[1])) {
                        _valid2 = false;
                    }
                    if (_seg3.test(_check[2])) {
                        _valid3 = false;
                    }
                    if (_valid1 && _valid2 && _valid3) {
                        return inputText;
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return '';
                }
            }
            else if (inputText.length >= 12) {
                var _firstcharacters = inputText.substring(0, 4);
                var _secondCharacters = inputText.substring(5, 10);
                var _thirdCharacters = inputText.substring(11, 13);
                return _firstcharacters + '/' + _secondCharacters + '/' + _thirdCharacters;
            }
            return '';
        }
        function deleteContent(event) {
            if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                var reg = event.target.value;
                event.target.value = dfcBusinessFormatBusinessReg(reg);
            }
        }
        function addBlur(event) {
            var reg = event.target.value;
            event.target.value = dfcBusinessFormatExpression(reg);
        }
        this.businessOtherDropdown();
        if ((this.businessType.value === "Private_Company") || (this.businessType.value === "Close_Corporation")) {
            var field = this.form.querySelector("input.form__input--identification");
            if (field) {
                var formGroupItem = field.closest(".form__group");
                formGroupItem.classList.remove("form__group--error");
                var labelItem = formGroupItem.querySelector('label');
                labelItem.innerText = "Business Registration Number";
                var newBusRegField = document.createElement('input');
                newBusRegField.setAttribute("name", "business-reg-number");
                newBusRegField.classList.add("form__input");
                newBusRegField.classList.add("form__input--required");
                newBusRegField.classList.add("form__input--busReg");
                newBusRegField.classList.add("form__input--business-registration");
                newBusRegField.placeholder = "Enter your business registration number";
                // This adds slashes to the business registration number
                newBusRegField.addEventListener("input", deleteContent);
                newBusRegField.addEventListener("blur", addBlur);
                newBusRegField.addEventListener("blur", function (pEvent) {
                    _this.validationService.validateBlur(pEvent.currentTarget);
                });
                field.parentNode.replaceChild(newBusRegField, field);
            }
        }
        else {
            // This removes event listener
            var field = this.form.querySelector("input.form__input--business-registration");
            if (field) {
                var formGroupItem = field.closest(".form__group");
                formGroupItem.classList.remove("form__group--error");
                var labelItem = formGroupItem.querySelector('label');
                labelItem.innerText = "ID Number";
                var newIdField = document.createElement('input');
                newIdField.setAttribute("name", "id-number");
                newIdField.setAttribute("maxlength", "13");
                newIdField.classList.add("form__input");
                newIdField.classList.add("form__input--required");
                newIdField.classList.add("form__input--identification");
                newIdField.placeholder = "Enter your South African ID number";
                newIdField.addEventListener("blur", function (pEvent) {
                    _this.validationService.validateBlur(pEvent.currentTarget);
                });
                field.parentNode.replaceChild(newIdField, field);
            }
        }
    };
    FormItemDfcBusinessGym.prototype.businessOtherDropdown = function () {
        var field = this.businessType;
        var formGroup = field.closest(".form__group");
        var formGroups = Array.from(this.element.querySelectorAll(".form__group"));
        var formNote = this.element.querySelector(".apply-now__note");
        var formButtons = this.element.querySelector(".apply-now__buttons");
        var formOtherContainer = this.element.querySelector(".form__business-other--container");
        if (this.businessType.value === "OtherContent") {
            formGroups.map(function (item) {
                item.classList.add("form__group--hidden");
            });
            formNote.classList.add("hidden");
            formButtons.classList.add("hidden");
            formOtherContainer.classList.add("active");
        }
        else {
            formGroups.map(function (item) {
                item.classList.remove("form__group--hidden");
            });
            formNote.classList.remove("hidden");
            formButtons.classList.remove("hidden");
            formOtherContainer.classList.remove("active");
        }
        formGroup.classList.remove("form__group--hidden");
    };
    FormItemDfcBusinessGym.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // fields
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var description = form.querySelector("input[name=description]");
        var firstname = form.querySelector("input[name=first-name]");
        var lastname = form.querySelector("input[name=last-name]");
        var businessType = form.querySelector("select[name=business-type]");
        var businessName = form.querySelector("input[name=business-name]");
        var phoneNumber = form.querySelector("input[name=phone-number]");
        var altPhoneNumber = form.querySelector("input[name=alternative-number]");
        var emailAddress = form.querySelector("input[name=email-address]");
        var businessRegNumber = form.querySelector("input[name=business-reg-number]");
        var idnumber = form.querySelector("input[name=id-number]");
        var existingCustomer = form.querySelector("input[name=existing-customer]");
        var recipient = form.querySelector('input[name=recipient]');
        var _postData = {
            'recipient': (recipient ? recipient.value : ''),
            'description': (description ? description.value : ""),
            'businessDescription': (description ? description.value : ""),
            'firstname': (firstname ? firstname.value : ""),
            'surname': (lastname ? lastname.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'businessType': (businessType ? businessType.value.replace(/_/g, " ") : ""),
            'businessName': (businessName ? businessName.value : ""),
            'contactNo': (phoneNumber ? phoneNumber.value : ""),
            'AltContactNo': (altPhoneNumber ? altPhoneNumber.value : ""),
            'email': (emailAddress ? emailAddress.value : ""),
            'businessRegNumber': (businessRegNumber ? businessRegNumber.value : ""),
            'idNumber': (idnumber ? idnumber.value : ""),
            'isExistingCustomer': ((existingCustomer ? (existingCustomer.checked ? "YES" : "NO") : "")),
            'popiConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'source': this.formsService.isMobile(),
            'dataSharingGroup': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(form, 'data-sharing-boarders')
        };
        // service
        var url = this.baseUrl + '/services/SubmitApplicationFormBizBankV1.jsp';
        this.formsService.postForm(url, this.http.serialiseObject(_postData)).then(function (pResponse) {
            // service ok
            loader.classList.remove("active");
            if (pResponse.data && pResponse.data === "invalid") {
                _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url);
                fieldsContainer.classList.remove("hidden");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", pResponse.data);
                thankYou.classList.add("active");
                var _documents = thankYou.querySelector(".form__thankyou--documents");
                var responseRef = pResponse.data.trim();
                if (_documents) {
                    _documents.removeAttribute("style");
                    var _buttonContainer = _documents.querySelector(".form__thank--documents-button");
                    var _subject = "My Reference Number Is: " + responseRef;
                    var _body = "To Whom It May Concern\n\nAttached please find a copy of the following documents as requested:\n\nID of owners and signatories\nProof of address not older than 3 months\nCompany registration documents if a registered company";
                    var _mailtoText = "mailto:SmallEnterpriseSales@standardbank.co.za?subject=" + encodeURIComponent(_subject) + "&body=" + encodeURIComponent(_body);
                    var _newButton = document.createElement("a");
                    _newButton.classList.add("button", "button--large", "button--centered", "button--main");
                    _newButton.setAttribute("data-id", "link_content_ documents email click");
                    _newButton.setAttribute("data-text", "email documents button click");
                    _newButton.setAttribute("href", _mailtoText);
                    var _text = document.createTextNode("EMAIL DOCUMENTS");
                    _newButton.appendChild(_text);
                    _buttonContainer.innerHTML = "";
                    _buttonContainer.appendChild(_newButton);
                }
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode | service failure occurred | " + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
    };
    FormItemDfcBusinessGym.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemDfcBusinessGym.prototype.resetForm = function () {
        var _this = this;
        var field = this.form.querySelector("input.form__input--business-registration");
        if (field) {
            var formGroupItem = field.closest(".form__group");
            formGroupItem.classList.remove("form__group--error");
            var labelItem = formGroupItem.querySelector('label');
            labelItem.innerText = "ID Number";
            var newIdField = document.createElement('input');
            newIdField.setAttribute("name", "id-number");
            newIdField.setAttribute("maxlength", "13");
            newIdField.classList.add("form__input");
            newIdField.classList.add("form__input--required");
            newIdField.classList.add("form__input--identification");
            newIdField.placeholder = "Enter your South African ID number";
            newIdField.addEventListener("blur", function (pEvent) {
                _this.validationService.validateBlur(pEvent.currentTarget);
            });
            field.parentNode.replaceChild(newIdField, field);
        }
    };
    return FormItemDfcBusinessGym;
}(Base));
export { FormItemDfcBusinessGym };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-dfc-business-gym/form-item-dfc-business-gym.component.ts
// module id = 985
// module chunks = 0